import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Link, Outlet } from '@tanstack/react-router';
import { EmptyState } from '@oex/ui';
import { Compass } from 'lucide-react';
import { ErrorView } from '../app/error-boundary';
import { t } from '../app/i18n';
import { AppProviders } from '../app/providers';

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: () => (
    <AppProviders>
      <a href="#main" className="sr-only focus:not-sr-only">
        {t('app.skip')}
      </a>
      <Outlet />
    </AppProviders>
  ),
  errorComponent: ({ error, reset }) => <ErrorView error={error} reset={reset} />,
  notFoundComponent: () => (
    <EmptyState
      icon={Compass}
      title={t('app.notFound.title')}
      body={t('app.notFound.body')}
      action={<Link to="/">{t('app.notFound.home')}</Link>}
    />
  ),
});
